import { getOwner } from '@ember/application';
import { registerDestructor } from '@ember/destroyable';
import Service, { service } from '@ember/service';

/**
 * Eagerly instantiated services that subscribe to `messagingInternalEvents` in their constructor,
 * ensuring their listeners exist before websocket activity arrives.
 */
const ACTIVITY_REACTOR_SERVICE_NAMES = ['conversation-draft-events', 'conversation-access-events'];

/**
 * Manages the client session lifecycle by eagerly initializing event reactors and opening/closing the websocket.
 */
export default class MessagingSessionService extends Service {
  @service('websocket/messagingWebsocket') messagingWebsocket;

  constructor() {
    super(...arguments);
    registerDestructor(this, () => this.stop());
  }

  start(messagingApiUrl) {
    const owner = getOwner(this);
    ACTIVITY_REACTOR_SERVICE_NAMES.forEach(serviceName => owner.lookup(`service:${serviceName}`));

    this.messagingWebsocket.openSocket(messagingApiUrl);
    this.messagingWebsocket.subscribeToCurrentUserActiveConversation();
  }

  stop() {
    this.messagingWebsocket.closeSocket();
  }
}
